module.exports = __webpack_public_path__ + "static/media/icon-entertainment.ea143ceb.svg";